import classNames from "classnames";
import React, { useCallback, useEffect, useRef } from "react";
import { useAppContext } from "../../Contexts/AppContext";
import { useMapContext } from "../../Contexts/MapContext";
import { getMap } from "../GeoLiteMap";
import { IBookmark } from "./BookmarksWidget";

export const Bookmark = ({ bookmark }: { bookmark: IBookmark }): JSX.Element => {
    const { bookmarks, setBookmarks, selectedBookmarkId, setSelectedBookmarkId } = useAppContext();
    const { setBaseMap } = useMapContext();

    const inputRef = useRef<HTMLInputElement>();

    useEffect(() => {
        inputRef.current &&
            selectedBookmarkId &&
            selectedBookmarkId === bookmark.id &&
            setTimeout(() => inputRef.current.focus(), 250);
    }, [selectedBookmarkId]);

    const onChangeName = useCallback(
        (name: string) => {
            const newBookmarks = [...bookmarks];
            newBookmarks.map((b) => b.id === bookmark.id && (b.name = name));
            setBookmarks(newBookmarks);
        },
        [bookmarks]
    );

    const onClick = () =>
        getMap()
            .getView()
            .fit(bookmark.extent, { duration: 1000, callback: () => setBaseMap(bookmark.basemap) });

    const onDelete = useCallback(() => setBookmarks([...bookmarks].filter((b) => b.id !== bookmark.id)), [bookmarks]);

    const onKeyDown = (e) => {
        if (e.code === "Enter" || e.code === "NumpadEnter" || e.code === "Escape") {
            setSelectedBookmarkId(null);
            inputRef.current && inputRef.current.blur();
        }
    };

    const onBlur = () => {
        inputRef.current && inputRef.current.blur();
        setSelectedBookmarkId(null);
    };

    return (
        <div className={classNames("bookmark", { selected: bookmark.id === selectedBookmarkId })}>
            <div className="bookmark-item">
                <div className="bookmark-content">
                    <img className="thumbnail" src={bookmark.image} onClick={onClick}></img>
                    <div className="input-container">
                        <input
                            ref={inputRef}
                            type="text"
                            placeholder={"Ievadiet nosaukumu"}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeName(e.target.value)}
                            value={bookmark.name}
                            onFocus={() => setSelectedBookmarkId(bookmark.id)}
                            onBlur={onBlur}
                            onKeyDown={onKeyDown}
                        />
                    </div>
                </div>
                <div className="bookmark-tools">
                    <div className="button" onClick={onDelete}>
                        <span className="icon-geolite-trash"></span>
                    </div>
                </div>
            </div>
        </div>
    );
};
